import CucaProductType from '../../enums/cuca-product-type.enum';

export const getProductType = (product) => {
  if (product.isMkp === undefined || !product.oc) {
    return CucaProductType.NONE_VALUE;
  }

  if (product.isMkp && product.oc) {
    return CucaProductType.RIPLEYMRKTPRODUCT;
  }

  if (!product.isMkp && product.oc) {
    return CucaProductType.RIPLEYPRODUCT;
  }
};

export const isMkp = (oc) => oc.includes('-' || 'MPM');
